import { Model, attr } from '@elatonsev/js-models';

export default class CityModel extends Model {
  name = attr('string');
  latitude = attr('string');
  longitude = attr('string');
  map_zoom = attr('string');
}